/**
 * The rule for a password a person chooses for themselves — never a temporary one, which the server
 * draws. The API enforces it (`POST /auth/password`); the web checks it first, only to say so sooner.
 */

/** What `create-admin.ts` has always required of the admin's password. */
export const PASSWORD_MIN_LENGTH = 12;
/** Sign-in takes at most this many characters, so a longer password could never be used. */
export const PASSWORD_MAX_LENGTH = 500;

/** Why `newPassword` will not do, in words to show the person, or null when it will. */
export function newPasswordProblem(newPassword: string, currentPassword: string): string | null {
  if (newPassword.length < PASSWORD_MIN_LENGTH) return `Use at least ${PASSWORD_MIN_LENGTH} characters.`;
  if (newPassword.length > PASSWORD_MAX_LENGTH) return `Use at most ${PASSWORD_MAX_LENGTH} characters.`;
  if (newPassword === currentPassword) return 'Choose a password different from the one you have now.';
  return null;
}
